<script>
import LogoApp from "@/components/logo.vue";
import InputField from "@/components/input/InputField.vue";
import {api} from "@/modules/api";

export default {
  name: 'ResetPassword',
  components: {InputField, LogoApp},
  data () {
    return {
      token: this.$route.params.token,
      formData: {},
      error: ''
    }
  },
  methods: {
    submit () {
      if (this.formData.password !== this.formData.currentPwd) {
        this.error = 'Les mots de passe ne sont pas identique'
      }
      api.profil.resetPassword(this.token, this.formData).then(() => {
        this.$router.push('/')
      })
    }
  }
}
</script>

<template>
  <section class="bg-gray-50 dark:bg-gray-900">
    <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <logo-app />
      <div class="w-full p-6 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md dark:bg-gray-800 dark:border-gray-700 sm:p-8">
        <h2 class="mb-1 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
          Modifier mot de passe
        </h2>
        <div class="mt-4 space-y-4 lg:mt-5 md:space-y-5">
          <input-field
            v-model="formData.email"
            label="Email"
            placeholder="example@deglingo.fr"
          />
          <input-field
            v-model="formData.password"
            label="Nouveau mot de passe"
            placeholder="••••••••"
            type="password"
          />
          <input-field
              v-model="formData.confirmePwd"
              label="Confirme mot de passe"
              placeholder="••••••••"
              type="password"
          />
          <p class="text-red-600">
            {{ error }}
          </p>
          <button @click="submit" class="w-full text-white bg-primary-700 hover:bg-primary-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
            Modifier mot de passe
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
